import { render, staticRenderFns } from "./UserPasswordDialog.vue?vue&type=template&id=457c7646&scoped=true"
import script from "./UserPasswordDialog.vue?vue&type=script&lang=js"
export * from "./UserPasswordDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457c7646",
  null
  
)

export default component.exports